/**
 * Shared vehicle edit data structure for appointment/schedule modals.
 */

import { VehicleData } from '../types';

export interface EditingVehicleData {
  id: string;
  licensePlate: string;
  state: string;
  vehicleData: Omit<VehicleData, 'id'>;
}

/**
 * Build editing vehicle data from a vehicle object (API or form shape).
 */
export function buildEditingVehicleData(vehicle: any): EditingVehicleData {
  return {
    id: vehicle.id,
    licensePlate: vehicle.license_plate || vehicle.licensePlate || '',
    state: vehicle.state || '',
    vehicleData: {
      status: vehicle.status || 'active',
      vin: vehicle.vin || '',
      year: vehicle.year || 0,
      make: vehicle.make || '',
      model: vehicle.model || '',
      state: vehicle.state || '',
      plate: vehicle.license_plate || vehicle.licensePlate || '',
      _utc: vehicle._utc || new Date().toISOString(),
      last_updated: vehicle.last_updated || new Date().toISOString(),
      cached: vehicle.cached || 'false'
    }
  };
}
